import { render, staticRenderFns } from "./fplace.vue?vue&type=template&id=3134d164&scoped=true"
import script from "./fplace.vue?vue&type=script&lang=js"
export * from "./fplace.vue?vue&type=script&lang=js"
import style0 from "./fplace.vue?vue&type=style&index=0&id=3134d164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134d164",
  null
  
)

export default component.exports